"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CookieInfos;
var _react = _interopRequireWildcard(require("react"));
var _CheckboxEl = _interopRequireDefault(require("Components/Forms/Elements/Managed/CheckboxEl"));
var _cookies_config = _interopRequireDefault(require("Components/Cookies/cookies_config"));
var _CookiesStore = _interopRequireDefault(require("Components/Stores/CookiesStore"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _utilities = require("Shared/utilities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const NO_STATUS = {};
function CookieInfos({
  code,
  ...props
}) {
  const config = _cookies_config.default[code] || {};
  const id = 'cookie-config-toggle-' + code;
  const status = _CookiesStore.default.useState(function (store) {
    return store['enabled_' + code];
  });
  const checked = (0, _utilities.isTrue)(status);
  const is__disabled = (0, _utilities.isTrue)(props.disabled) || (0, _utilities.isTrue)(config.disabled);
  const toggle = (0, _react.useCallback)(function (e) {
    _CookiesStore.default.update(function (store) {
      store['enabled_' + code] = !(0, _utilities.isTrue)(store['enabled_' + code]);
    });
    window.localStorage.setItem('cookies_consent', 'custom');
  }, [code]);
  const is__status_false = (0, _utilities.isFalse)(status);
  const modifiers = (0, _react.useMemo)(function () {
    return [code].concat(checked ? ['checked'] : is__status_false ? ['disabled'] : []);
  }, [code, checked, is__status_false]);
  if (!_cookies_config.default[code]) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _bemit.default)('c-cookie-parameter', modifiers),
    "data-cookie-config-code": code
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-cookie-parameter__title"
  }, config.title), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-cookie-parameter__value"
  }, /*#__PURE__*/_react.default.createElement(_CheckboxEl.default, {
    name: 'cookie-switch-' + code,
    onChange: is__disabled ? undefined : toggle,
    checked: checked,
    bemit: ['switch'],
    status: NO_STATUS,
    disabled: is__disabled,
    id: id,
    className: "c-cookie-parameter__switch"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "c-cookie-parameter__status"
  }, checked ? 'Actif' : 'Inactif')), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-cookie-parameter__description",
    dangerouslySetInnerHTML: {
      __html: config.description || ''
    }
  }));
}
